<template>
  <clip-loader :loading="loading" color="#337ab7"></clip-loader>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader'

  export default {
    components: {
      ClipLoader
    },
    data () {
      return {
        loading: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Loader.vue?6ad51056